import * as React from 'react';
import styles from './index.less';
import {
  OnChange_Page_Action,
  OnMount_Page_Action as OnMount_Sidebar_Action,
  OnUpdate_Data_Action,
} from '@/models/resourceSider';
import { RouteComponentProps } from 'react-router/index';
import { Dispatch } from 'redux';
import * as AHooks from 'ahooks';
import { withRouter } from 'umi';
import { connect } from 'dva';
import { ConnectState } from '@/models/connect';
import FMicroAPP_Authorization from '@/components/FMicroAPP_Authorization';
import {
  ChangeAction,
  HandleDataAction,
  OnMount_Page_Action,
  OnUnmount_Page_Action,
  ResourceDependencyPageState,
} from '@/models/resourceDependencyPage';
import FComponentsLib from '@freelog/components-lib';
import { FI18n } from '@freelog/tools-lib';
// import FDropdownMenu from '@/components/FDropdownMenu';
import FDropdown2 from '@/components/FDropdown2';

interface DependencyProps extends RouteComponentProps<{ id: string }> {
  dispatch: Dispatch;
  resourceDependencyPage: ResourceDependencyPageState;
}

function Dependency({ dispatch, resourceDependencyPage, match }: DependencyProps) {
  AHooks.useMount(async () => {
    dispatch<OnMount_Sidebar_Action>({
      type: 'resourceSider/onMount_Page',
      payload: {
        resourceID: match.params.id,
      },
    });
    dispatch<OnChange_Page_Action>({
      type: 'resourceSider/onChange_Page',
      payload: {
        page: 'dependency',
      },
    });
    dispatch<OnMount_Page_Action>({
      type: 'resourceDependencyPage/onMount_Page',
      payload: {
        resourceID: match.params.id,
      },
    });
  });

  AHooks.useUnmount(() => {
    dispatch<OnUnmount_Page_Action>({
      type: 'resourceDependencyPage/onUnmount_Page',
    });
  });

  return (
    <div>
      <div style={{ height: 40 }} />
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
          <FComponentsLib.FContentText
            text={`${FI18n.i18nNext.t('edit_resource_relynauth_filter_version')}`}
            type={'normal'}
            singleRow
          />
          {/* <FDropdownMenu
            options={resourceDependencyPage.versions}
            onChange={async (value) => {
              await dispatch<ChangeAction>({
                type: 'resourceDependencyPage/change',
                payload: {
                  version: value,
                },
              });
              await dispatch<HandleDataAction>({
                type: 'resourceDependencyPage/handleData',
              });
            }}
            text={
              resourceDependencyPage.versions.find((v) => {
                return v.value === resourceDependencyPage.version;
              })?.text || ''
            }
          /> */}

          <FDropdown2
            autoArrow={true}
            // getPopupContainer={() => ref_Root.current as HTMLElement}
            menu={{
              selectedKeys: [resourceDependencyPage.version],
              items: resourceDependencyPage.versions.map((rs) => {
                return {
                  key: rs.value,
                  label: <div style={{ minWidth: 60 }}>{rs.text}</div>,
                };
              }),
              onClick: async (value) => {
                await dispatch<ChangeAction>({
                  type: 'resourceDependencyPage/change',
                  payload: {
                    version: value.key,
                  },
                });
                await dispatch<HandleDataAction>({
                  type: 'resourceDependencyPage/handleData',
                });
              },
            }}
          >
            <span>
              {resourceDependencyPage.versions.find((v) => {
                return v.value === resourceDependencyPage.version;
              })?.text || ''}
            </span>
          </FDropdown2>
        </div>
      </div>
      <div style={{ height: 20 }} />
      <div className={styles.block}>
        {resourceDependencyPage.reload > 0 && (
          <FMicroAPP_Authorization
            // reload={resourceDependencyPage.reload}
            licenseeId={resourceDependencyPage.resourceID}
            mainAppType={'resourceDepAuth'}
            depList={resourceDependencyPage.directDependencies}
            upcastList={resourceDependencyPage.baseUpcastResources}
            // reload={resourceDependencyPage.reload}
            update={(value) => {
              dispatch<OnUpdate_Data_Action>({
                type: 'resourceSider/onUpdate_Data',
                // payload: resourceAuthPage.resourceID,
              });
            }}
          />
        )}
      </div>
      <div style={{ height: 100 }} />
    </div>
  );
}

export default withRouter(
  connect(({ resourceDependencyPage }: ConnectState) => ({
    resourceDependencyPage: resourceDependencyPage,
  }))(Dependency),
);
